import React, { useContext } from 'react';
import GlobalContext from '../../contexts/GlobalContext';

type ThankYouPopupProps = {
  message: string;
  closePopUp: Function;
};

const ThankYouPopup = (props: ThankYouPopupProps): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const clickOkayButton = (): void => {
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      'ClickOkayButton',
      '',
      null,
      true
    );
    document.body.classList.remove('is-reveal-open');
    props.closePopUp();
  };

  return (
    <div className="privacy-ccpa-thanks">
      <div className="regulatory-updates-modal__header">
        <h2 className="regulatory-updates__heading js-regulatory-updates-modal-heading">
          Privacy Requests
        </h2>
      </div>
      <p className="regulatory-updates__para privacy-ccpa-thanks__para">
        {props.message}
      </p>
      <div>
        <button
          className="base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation"
          type="submit"
          onClick={(): void => clickOkayButton()}>
          okay
        </button>
      </div>
    </div>
  );
};

export default ThankYouPopup;
